import React, { useState, useEffect, useRef } from 'react';
import './FadeInSectionDownToUp.css';

const FadeInSectionDownToUp = ({ children }) => {
    const [isVisible, setVisible] = useState(false);
    const domRef = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                setVisible(entry.isIntersecting);
            });
        });

        const { current } = domRef;
        observer.observe(current);

        return () => {
            observer.unobserve(current);
        };
    }, []);

    return (
        <div
            className={`fade-in-section-down-to-up ${isVisible ? "is-visible-down-to-up" : ""}`}
            ref={domRef}
        >
            {children}
        </div>
    );
};

export default FadeInSectionDownToUp;
